"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var Footer = function Footer(props) {
  var className = props.className,
    children = props.children;
  var footerClasses = [vdl_prefix_1.vdlPrefix('footer')];
  return react_1.default.createElement("footer", {
    className: classnames_1.classNames(className, footerClasses)
  }, children);
};
exports.Footer = Footer;
exports.Footer.propTypes = {
  className: prop_types_1.default.string
};
exports.Footer.displayName = 'Footer';